import React, { useRef } from "react";
import SunEditor from "suneditor-react";
// Info: 특정 플러그인 추가하는 방법
// import { font, image, fontSize, formatBlock } from "suneditor/src/plugins";
import "suneditor/dist/css/suneditor.min.css";

const CustomSunEditor = ({ value = "", setValue }) => {
    const editor = useRef();

    const getSunEditorInstance = (sunEditor) => {
        editor.current = sunEditor;
    };

    const handleChange = (content) => {
        const isEmpty = content === "<p><br></p>" || content === "";
        setValue(isEmpty ? "" : content);
    };

    return (
        <div>
            <SunEditor
                getSunEditorInstance={getSunEditorInstance}
                width="100%"
                height="400px"
                setOptions={{
                    defaultStyle: "font-family: Pretendard, 'Noto Sans KR', sans-serif; font-size: 14px;",
                    font: [
                        "Pretendard",
                        "Noto Sans KR",
                        "Nanum Gothic",
                        "Nanum Myeongjo",
                        "Black Han Sans",
                        "Malgun Gothic",
                        "Apple SD Gothic Neo",
                    ],
                    buttonList: [
                        ["undo", "redo"],
                        ["font", "fontSize", "formatBlock"],
                        ["paragraphStyle", "blockquote"],
                        ["bold", "underline", "italic", "strike"],
                        ["fontColor", "hiliteColor"],
                        ["outdent", "indent"],
                        ["align", "horizontalRule", "list", "lineHeight"],
                        ["table", "link", "image"],
                        ["fullScreen", "showBlocks", "codeView"],
                        ["removeFormat"],
                    ],
                    // plugins: [font, image, fontSize, formatBlock] // Info: 특정 플러그인만 사용할 경우
                }}
                setAllPlugins={true} // 모든 플러그인 사용 시
                onChange={handleChange}
                defaultValue={value}
            />
        </div>
    );
};

export default CustomSunEditor;
